export const ageMethod = "age nearest";
export const gateway = "https://guild-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/guild";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJndWlsZCIsIm5hbWUiOiJndWlsZCIsImlhdCI6MTc3OTkyMzg5OCwiZXhwIjoxOTM3NzExODk4fQ.J4a3FEQKHZaUEw6Zd8GhRE3RAkau4-uiZEKgqDm_xAY";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"guild.link.wawanesalife.com": {
		a: {
			approve_company: "CENTRAL",
			approve_user: "link_guild",
			brands: [
				"guild.link.wawanesalife.com",
			],
			broker: "guild",
			broker_formatted_name: "Guild Insurance Group",
			email: "info@guild.ca",
			environment: "stable",
			environment_id: "stable",
			g4: "G-14ZL6551EP",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-866-277-4949",
			privacyLink: "https://www.guild.ca/our-privacy-policy/",
			video_link: "oyQBe3TRMPw",
			website: "https://guild.ca/",
			scope: "guild#branding#guild.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "guild.link.wawanesalife.com",
		},
		b: {
			approve_company: "CENTRAL",
			approve_user: "link_guild",
			brands: [
				"guild.link.wawanesalife.com",
			],
			broker: "guild",
			broker_formatted_name: "Guild Insurance Group",
			email: "info@guild.ca",
			environment: "stable",
			environment_id: "stable",
			g4: "G-14ZL6551EP",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "1-866-277-4949",
			privacyLink: "https://www.guild.ca/our-privacy-policy/",
			video_link: "oyQBe3TRMPw",
			website: "https://guild.ca/",
			scope: "guild#branding#guild.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "guild.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 18:18:18 GMT-0500 (Central Daylight Time)
